import angular from "angular";

angular
    .module('core.auth', [])
    .value('Auth.Roles', null)
    .value('Auth.Permissions', null)
    .value('Auth.User', null)
    .service('Auth', ['Auth.User', 'Auth.Roles', 'Auth.Permissions', function (user, roles, permissions) {

        this.user = user;

        this.can = function (key) {
            for (let i = 0; i < permissions.length; i++) {
                if (permissions[i] == key) {
                    return true;
                }
            }
            return false;
        };

        this.hasRoles = function (roleKeys) {
            for (let i = 0; i < roleKeys.length; i++) {
                let arr = roleKeys[i].split('.');
                let type = arr[0];
                let role = arr[1];

                if (type != this.user.type) {
                    continue;
                }
                if (roles.indexOf(role) != -1) {
                    return true;
                }
            }
            return false;
        };

    }]);

export default 'core.auth';


// WEBPACK FOOTER //
// ./resources/assets/modules/core/auth.service.js